export function memoize(func, context) {
  return function (...args) {
    this._memoized ??= {}

    return this._memoized[context.name] ??= func.call(this, ...args);
  };
}
